import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import apiPaths from '../helpers/apiPaths';
import shipmentsApi from '../apis/swagup/shipments';
import { SHIPMENTS_HAVE_INVALID_ADDRESS } from '../actions/types';
import { shipmentStatus } from '../apis/constants';
import { fiveMinutes } from '../helpers/helperConstants';

const useHasInvalidAddress = () => {
  const dispatch = useDispatch();

  const query = useQuery(
    [apiPaths.employeeOrders, { limit: 4 }],
    () => shipmentsApi.fetch({ limit: 4, isCancellable: false }),
    {
      onSuccess: data => {
        dispatch({
          type: SHIPMENTS_HAVE_INVALID_ADDRESS,
          payload: data.results[0]?.status === shipmentStatus.invalidAddress
        });
      },
      refetchInterval: fiveMinutes,
      staleTime: fiveMinutes
    }
  );

  return query;
};

export default useHasInvalidAddress;
